import { registerTour } from "../tourRegistry";

function getSteps() {
  const totalSteps = 7;
  const stepCounter = (n) => `Step ${n} of ${totalSteps}`;

  return [
    {
      id: 'is-overview',
      title: `Income Statement <span class="t3-shepherd-step-count">${stepCounter(1)}</span>`,
      text: 'The Income Statement shows your organization\'s income and expenses over a date range. Data updates in real time from your latest transactions.',
      attachTo: { element: '[data-tour="is-page"]', on: 'bottom' },
      buttons: [
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'is-mode-toggle',
      title: `Report Modes <span class="t3-shepherd-step-count">${stepCounter(2)}</span>`,
      text: 'Switch between three views: <strong>By Fund</strong> shows income/expenses per fund. <strong>By Label</strong> groups by label category. <strong>By Budget</strong> compares your budget to actual spending with variance calculations.',
      attachTo: { element: '[data-tour="is-mode-toggle"]', on: 'left' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'is-open-customize',
      title: `Customize Report <span class="t3-shepherd-step-count">${stepCounter(3)}</span>`,
      text: 'Customize your report by adjusting dates, selecting funds, and configuring display options.',
      attachTo: { element: '[data-tour="is-customize-btn"]', on: 'bottom' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Open Settings',
          classes: 't3-shepherd-next-btn',
          action() {
            const btn = document.querySelector('[data-tour="is-customize-btn"]');
            if (btn) btn.click();
            setTimeout(() => this.next(), 300);
          },
        },
      ],
    },
    {
      id: 'is-date-range',
      title: `Date Range & Filters <span class="t3-shepherd-step-count">${stepCounter(4)}</span>`,
      text: 'Set the reporting period here. The default is your <strong>financial year-to-date</strong> (not calendar year). Select specific funds to include or exclude, and toggle options like showing cents.',
      attachTo: { element: '[data-tour="is-customize-drawer"]', on: 'left' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Close Settings',
          classes: 't3-shepherd-next-btn',
          action() {
            const btn = document.querySelector('[data-tour="is-customize-btn"]');
            if (btn) btn.click();
            setTimeout(() => this.next(), 300);
          },
        },
      ],
    },
    {
      id: 'is-collapse-rows',
      title: `Expand & Collapse Rows <span class="t3-shepherd-step-count">${stepCounter(5)}</span>`,
      text: 'Click the arrow (\u25B6) next to any account group to expand or collapse it. <strong>When you collapse a section, the numbers automatically sum up to show the group total.</strong> This works for account types, individual accounts, and fund columns.',
      attachTo: { element: '[data-tour="is-collapse-row"]', on: 'top' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'is-export',
      title: `Export Options <span class="t3-shepherd-step-count">${stepCounter(6)}</span>`,
      text: 'Export your report as PDF or Excel. The export includes all currently visible data with your selected filters and date range applied.',
      attachTo: { element: '[data-tour="is-export-buttons"]', on: 'bottom' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'is-nav',
      title: `Report Navigation <span class="t3-shepherd-step-count">${stepCounter(7)}</span>`,
      text: 'Switch between report types using the navigation pills above — Balance Sheet, Income Statement, General Ledger, and more.',
      attachTo: { element: '[data-tour="nav-top-pills"]', on: 'bottom' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Done',
          classes: 't3-shepherd-next-btn',
          action() { this.complete(); },
        },
      ],
    },
  ];
}

registerTour({
  id: 'incomeStatement',
  pathPattern: '/reports/income-statement',
  getSteps,
  label: 'Income Statement Tour',
});
